import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { reactI18nextModule } from 'react-i18next'

/**
 * Cấu hình sử dụng I18next
 */
i18n
  // Các file ngôn ngữ được lưu ở thư mục /public/locales
  // Ngôn ngữ sẽ được load tương ứng
  .use(Backend)
  // Xác định ngôn ngữ người dùng sử dụng
  // Tài liệu: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // Thêm đối tượng i18n tới các react-i18next
  // Thay cho việc sử dụng I18nextProvider: https://react.i18next.com/components/i18nextprovider
  .use(reactI18nextModule)
  // Khởi tạo i18next
  // Chi tiết tham khảo: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'vi',
    debug: process.env.NODE_ENV !== 'production' ? true : false,
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },

    // special options for react-i18next
    // learn more: https://react.i18next.com/components/i18next-instance
    react: {
      wait: true
    }
  })

export default i18n
